import React, { Component, useSyncExternalStore } from "react";
import { StaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";
import PropTypes from "prop-types";

import carWiseOfferConfig from "./configs/carWiseOfferConfig";

import "../css/modalRange.less";
import "../css/globalRules.less";

const ModalRangeImage = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          taigun: file(relativePath: { eq: "modelRange/taigun.png" }) {
            childImageSharp {
              fluid(maxWidth: 1500) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          virtus: file(relativePath: { eq: "modelRange/virtus.png" }) {
            childImageSharp {
              fluid(maxWidth: 1500) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          tiguan: file(relativePath: { eq: "modelRange/tiguan.png" }) {
            childImageSharp {
              fluid(maxWidth: 1500) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={(data) => {
        let imagesObject = {};
        Object.keys(data).forEach((key) => {
          imagesObject[key] = data[key]?.childImageSharp.fluid;
        });
        return <Img fluid={imagesObject[props.modalRange]} alt="Image" />;
      }}
    />
  );
};

ModalRangeImage.propTypes = {
  modalRange: PropTypes.string.isRequired,
};

export default class ModalRange extends Component {
  handleTabClick(index) {
    this.setState({ activeIndex: index });
  }

  getCarListElementData = () => {
    let exclusiveData = Object.values(carWiseOfferConfig);
    const exclusiveCarList = [];
    const exclusiveFilterList = [];
    let selectedActiveCarData;
    let exclusiveSelectedCarIndex;
    let selectedActiveCarList;
    let selectedActiveCarListHeading;
    let selectedActiveCarTCLimited;
    for (let i = 0; i < exclusiveData?.length; i++) {
      const item = exclusiveData[i]?.carElements;
      exclusiveCarList.push(item);
      const { key } = item;
      if (this.props.carList.includes(key)) {
        exclusiveFilterList.push(item);
        exclusiveSelectedCarIndex = exclusiveFilterList?.findIndex(
          (item) => item.key === this.props.carName
        );
        const activeCarObject = carWiseOfferConfig?.[this.props.carName];
        selectedActiveCarData = activeCarObject?.carElements;
        selectedActiveCarList = activeCarObject?.carWiseOfferElements?.list;
        selectedActiveCarListHeading =
          activeCarObject?.carWiseOfferElements?.mainHeading;
        selectedActiveCarTCLimited =
          activeCarObject?.carWiseOfferElements?.carTcLimited;
      }
    }
    return {
      exclusiveSelectedCarIndex,
      exclusiveFilterList,
      selectedActiveCarData,
      selectedActiveCarList,
      selectedActiveCarListHeading,
      selectedActiveCarTCLimited,
    };
  };

  renderSpecialOffer = () => {
    const exclusiveSpecialOfferObject = this.getCarListElementData();
    const {
      selectedActiveCarListHeading,
      selectedActiveCarTCLimited,
      selectedActiveCarList,
    } = ({} = exclusiveSpecialOfferObject);
    return (
      <div className="container special-sec">
        <div className="main-heading text-center mb-4">
          Our Exclusive Offers
        </div>
        <div className="container mt-3">
          <div className="col-sm-12 col-md-12 col-lg-11 mx-auto border px-md-5 px-3 py-4">
            {selectedActiveCarListHeading && (
              <h3
                class="offer-mainheading"
                dangerouslySetInnerHTML={{
                  __html: selectedActiveCarListHeading,
                }}
              />
            )}
            <div class="text-center offer-block">
              {selectedActiveCarList?.map((item, index) => {
                const { firstDescription, secondDescription } = item;
                const selectedCarKey =
                  this.props.carName + "_" + index + "_offer";
                return (
                  <div class={`offer-box ${this.props.carName + index}`}>
                    <ModalRangeImage modalRange={selectedCarKey} />
                    <div
                      className={`offer-description offer-car-name-${
                        this.props.carName
                      } ${this.props.carName + index}`}
                    >
                      {firstDescription && (
                        <div
                          className="first-heading"
                          dangerouslySetInnerHTML={{ __html: firstDescription }}
                        />
                      )}
                      {secondDescription && (
                        <div
                          className="second-heading"
                          dangerouslySetInnerHTML={{
                            __html: secondDescription,
                          }}
                        />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {selectedActiveCarTCLimited && (
            <div
              className="col-sm-12 col-md-12 col-lg-11 mx-auto py-2 tc-condition-block"
              dangerouslySetInnerHTML={{ __html: selectedActiveCarTCLimited }}
            />
          )}
        </div>
      </div>
    );
  };

  render() {
    const exclusiveObject = this.getCarListElementData();
    const {
      exclusiveFilterList,
      selectedActiveCarData,
      exclusiveSelectedCarIndex,
      selectedActiveCarList,
    } = ({} = exclusiveObject);

    return (
      <>
        <div className="modal-range-cars-block container">
          <div className="main-heading">Find your Volkswagen</div>
          <div className="tab-list">
            {exclusiveFilterList?.map((tab, index) => (
              <div
                key={tab?.label}
                className={`tab ${
                  index === exclusiveSelectedCarIndex ? "active" : ""
                }`}
                onClick={() => this.handleTabClick(index)}
              >
                <Link to={`/${tab?.key}`}>{tab?.label}</Link>
              </div>
            ))}
          </div>
          <div className="col-md-12 mx-auto pt-3 range-inner">
            <div className="row align-items-center pt-2 pt-md-5">
              <div className="col-md-7">
                <ModalRangeImage modalRange={selectedActiveCarData?.key} />
              </div>
              <div className="col-md-5">
                <div className="title">{selectedActiveCarData?.label}</div>
                <div
                  className="price"
                  dangerouslySetInnerHTML={{
                    __html: selectedActiveCarData?.price,
                  }}
                ></div>
                <p
                  className="content-desc semibold description line-spacing-4"
                  dangerouslySetInnerHTML={{
                    __html: selectedActiveCarData?.content,
                  }}
                ></p>
                <p
                  className="sub-content-desc semibold"
                  dangerouslySetInnerHTML={{
                    __html: selectedActiveCarData?.subContent,
                  }}
                ></p>
                <p
                  className="sub-content-desc semibold"
                  dangerouslySetInnerHTML={{
                    __html: selectedActiveCarData?.subContent1,
                  }}
                ></p>
              </div>
            </div>
          </div>
        </div>
        {selectedActiveCarList?.length > 0 && this.renderSpecialOffer()}
      </>
    );
  }
}
